import request from '../../utils/request';

function getUsers(roles, pageNumber = null, limit = null) {
  return request({
    url: 'user/list',
    method: 'POST',
    data: {
      types: roles,
      pageNumber,
      limit,
    },
    private: true,
  });
}

function getUsersList(roles, pageNumber = null, pageSize = null, keyword = '') {
  return request({
    url: 'user/list',
    method: 'POST',
    data: {
      types: roles,
      pageNumber,
      pageSize,
      keyword,
    },
    private: true,
  });
}
function searchUsers(role, term) {
  return request({
    url: 'user/search',
    method: 'POST',
    data: {
      type: role,
      term,
    },
    private: true,
  });
}

function getUser(id) {
  return request({
    url: `user/get/${id}`,
    method: 'GET',
    private: true,
  });
}
function createUser(data) {
  return request({
    url: 'user/create',
    method: 'POST',
    private: true,
    data,
  });
}
function updateUser(id, data) {
  return request({
    url: `user/update/${id}`,
    method: 'PATCH',
    data,
    private: true,
  });
}

function updateUserRole(id, roleId) {
  return request({
    url: `user/update-role/${id}`,
    method: 'PATCH',
    data: { roleId },
    private: true,
  });
}

function getRoles() {
  return request({
    url: 'role/list',
    method: 'GET',
    private: true,
  });
}

function updateUserNew(id, data) {
  return request({
    url: `/user/update-profile/${id}`,
    method: 'PATCH',
    data,
    private: true,
  });
}

function deleteUser(id) {
  return request({
    url: `/user/delete/${id}`,
    method: 'DELETE',
    private: true,
  });
}
function updateMentorCalendar(schedules, date, user) {
  return request({
    url: `schedule/create`,
    method: 'POST',
    data: {
      schedules,
      date,
      user,
    },
    private: true,
  });
}
function getMentorCalendar(id) {
  return request({
    url: `schedule/get-by-user-external/${id}`,
    method: 'GET',
    private: true,
  });
}
function updateMenteePillars(pillars, user) {
  return request({
    url: '/user/pillars',
    method: 'PATCH',
    private: true,
    data: {
      pillars,
      user,
    },
  });
}
function getSessions(idUser) {
  return request({
    url: `/users/${idUser}/sessions`,
    method: 'GET',
    private: true,
  });
}
function getExtraData(idUser) {
  return request({
    url: `/users/${idUser}/extra`,
    method: 'GET',
    private: true,
  });
}
function updateExtraData(idUser, data) {
  return request({
    url: `users/${idUser}/extra`,
    method: 'PATCH',
    data: { data },
    private: true,
  });
}
function getBusySchedule(idMentor, idMentee) {
  return request({
    url: `schedules/busy/users/${idMentor}/${idMentee}`,
    method: 'GET',
    private: true,
  });
}
function getMentors(clientId = null, ref = null, announcementId = null) {
  return request({
    url: `/users/mentors`,
    method: 'GET',
    private: true,
    params: {
      clientId,
      referer: ref,
      announcementId,
    },
  });
}

function getUserById(id) {
  return request({
    url: `user/get-profile/${id}`,
    method: 'GET',
    private: true,
  });
}

function getMentorProfessionalExperience(idUser) {
  return request({
    url: `users/${idUser}/mentor-professional-experience`,
    method: 'GET',
    private: true,
  });
}

function getUserRestrictions(userId, activeOnly = false) {
  return request({
    url: '/user-restrictions',
    method: 'GET',
    private: true,
    params: {
      userId,
      activeOnly,
    },
  });
}

function createUserRestriction(data) {
  return request({
    url: '/user-restrictions',
    method: 'POST',
    private: true,
    data,
  });
}

function updateUserRestriction(id, data) {
  return request({
    url: `/user-restrictions/${id}`,
    method: 'PATCH',
    private: true,
    data,
  });
}

function deleteUserRestriction(id) {
  return request({
    url: `/user-restrictions/${id}`,
    method: 'DELETE',
    private: true,
  });
}

function createMassiveSessions({
  calendar,
  idMentee,
  idMentor,
  pillar,
  title,
  description,
  notify,
  clientId = 1,
  announcementId = null,
  guestEmails,
}) {
  return request({
    url: '/sessions/massive',
    method: 'POST',
    private: true,
    data: {
      calendar,
      idMentee,
      idMentor,
      pillar,
      title,
      description,
      notify,
      clientId,
      announcementId,
      guestEmails,
    },
  });
}
async function fetchPdfUser(id) {
  return await request({
    url: `/report/pdf-user/${id}`,
    method: 'GET',
    private: true,
  });
}
// Descarga el PDF del último diagnóstico (evaluador) finalizado del usuario.
// Devuelve el blob directamente para forzar la descarga sin abrir una pestaña.
async function downloadUserDiagnostico(userId) {
  const response = await request({
    url: `/admin/users/${userId}/evaluation/pdf`,
    method: 'GET',
    private: true,
    responseType: 'blob',
  });
  const blob = new Blob([response.data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `diagnostico-${userId}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
async function fetchIndicators(clientId = 1, ref = null) {
  return await request({
    url: `mentor/indicators`,
    method: 'GET',
    private: true,
    params: {
      clientId,
      referer: ref,
    },
  });
}
async function fetchNextToDueDate(pageNumber, pageSize) {
  return await request({
    url: 'mentor/get-next-to-duedate',
    method: 'GET',
    private: true,
    params: {
      pageNumber,
      pageSize,
    },
  });
}
const UsersAPI = {
  getUsers,
  searchUsers,
  getUser,
  createUser,
  updateUser,
  updateUserRole,
  getRoles,
  deleteUser,
  updateMentorCalendar,
  getMentorCalendar,
  updateMenteePillars,
  getSessions,
  getExtraData,
  updateExtraData,
  getBusySchedule,
  getMentors,
  createMassiveSessions,
  fetchPdfUser,
  downloadUserDiagnostico,
  fetchIndicators,
  fetchNextToDueDate,
  getUserById,
  getMentorProfessionalExperience,
  getUserRestrictions,
  createUserRestriction,
  updateUserRestriction,
  deleteUserRestriction,
  updateUserNew,
  getUsersList,
};

export default UsersAPI;
